import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
    title: string;
    message: string;
    confirm: boolean;
    confirmTitle: string;
    // Optional extra action button, rendered above the always-present Close
    // button (below Confirm, when that's also shown). Not used by most
    // callers - e.g. the "Create Snapshot" success dialog uses it for a
    // "View Snapshot" button that opens the new snapshot in a new window.
    actionTitle?: string;
    action?: () => void;
    // Optional label for the always-present Close button — defaults to
    // "Close", so every existing caller is unchanged. Used where "Close"
    // alone wouldn't say what declining means (e.g. the Planner's "keep
    // future planned blocks" prompt).
    cancelTitle?: string;
}

@Component({
    selector: 'alert-dialog',
    templateUrl: 'alert-dialog.component.html',
    styleUrls: ['alert-dialog.component.scss'],
})
export class AlertDialog {
    constructor(
        public dialogRef: MatDialogRef<AlertDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {}

    onCancel(): void {
        this.dialogRef.close();
    }

    onAction(): void {
        if (this.data.action) {
            this.data.action();
        }
        this.dialogRef.close();
    }
}
